import { languages, sidebarMenu } from "./data";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

export default {
  sidebarMenu,
  languages,
  selectedLocale: localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.LANGUAGE)).locale
    : languages[0].locale,
  isModalOpen: false,
  videoModal: {
    isOpen: false,
    videoUrl: null
  },
  modalData: {}
};
